import React, { useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { MapContainer, TileLayer, Marker, GeoJSON } from "react-leaflet";
import UserService from "../../api-service/UserService";
import GisLayerService from "../../api-service/GisLayerService";
import SessionHelper from "../../helpers/SessionHelper";
import FluentdHelper from "../../helpers/FluentdHelper";
import RegisterPanel from "./RegisterPanel";
import L from "leaflet";
import CheckGeoJson from "./CheckGeoJson";

import {
  LOGERROR,
  AVAILABLE,
  SELECTED,
  REGISTERED,
  CLAIM,
  ADDED,
  MAP_CENTER,
  SESSION_EXPIRED,
  SESSION_EXPIRED_MESSAGE,
  SHOW_FIELD,
  FIELDS,
  CLAIMS,
  RESOURCES,
  EMPTY,
  BLACK,
} from "../../configurations/Constants";
import _ from "lodash";
import Draggable from "react-draggable";
import Claim from "../registrationMap/Claim";
import AddField from "../registrationMap/AddField";

import { Popover, OverlayTrigger, Button } from "react-bootstrap";

import {
  selectPolygon,
  SetFlagToGetGeoJson,
  setAllGeoJsonPolygon,
  formType,
  setInitialFarms,
  setInitialBusiness,
} from "../../configurations/redux-configurations/actions/fieldAction";

import {
  USER_CLAIMED_FIELDS,
  USER_REGISTERED_FIELDS,
  REGISTER_FIELD_OVERLAY_LOADING_TEXT,
  SESSION_HAS_EXPIRED,
  INCOMING_TOKEN_HAS_EXPIRED,
  INVALID_CREDENTIALS,
  ERROR_FETCHING_ALL_IRRIGATION_FIELDS,
  ERROR_FETCHING_REGISTERED_FIELDS,
  ERROR_FETCHING_FIELD_DETAILS,
} from "../../configurations/MessageConstants";
import StorageHelper from "../../helpers/StorageHelper";
import LoadingOverlay from "../common/LoadingOverlay";
import ChangeMap from "../common/ChangeMap";
import { StatusCodes } from "../../configurations/status-codes";

let wellMarker;
let wellMarkerArray = [];

function RegisterMap(props) {
  const dispatch = useDispatch();
  const ActivePolygon = useSelector((state) => state.field.activePolygon);
  const AddedFields = useSelector((state) => state.field.addedFields);
  const AllGeoJson = useSelector((state) => state.field.allPolygons);
  const IsGeoJsonFetched = useSelector(
    (state) => state.field.isGeoJsonPolygonFetched
  );
  const loggedInUser = useSelector((state) => state.user.loggedInUser);
  const registeredUser = useSelector((state) => state.user.registeredUser);

  const [showOverlay, setShowOverlay] = useState(false);
  const [isWellShown, setIsWellShown] = useState(false);
  const [showPopover, setShowPopover] = useState(false);
  const [fieldName, setFieldName] = useState(EMPTY);
  const [farmName, setFarmName] = useState(EMPTY);
  const [well_details, setWell_details] = useState([
    {
      well_id: EMPTY,
      gpm: EMPTY,
      ugpm: EMPTY,
      activeWell: true,
      isElectricWell: true,
    },
  ]);
  const [popupVisible, setPopupVisible] = useState(false);
  const [surfaceWaterIrrigation, setSurfaceWaterIrrigation] = useState(false);
  const [showPanel, setShowPanel] = useState(true);
  const [registrationSucessful, setRegistrationSucessful] = useState(false);
  const [btnClaimEnabled, setBtnClaimEnabled] = useState(false);
  const [fieldError, setFieldError] = useState(false);
  const [fieldNameError, setFieldNameError] = useState(false);
  const [groundWaterPercentage, setGroundWaterPercentage] = useState(EMPTY);
  const [surfaceWaterPercentage, setSurfaceWaterPercentage] = useState(EMPTY);
  const [editField, setEditField] = useState(false);
  const [irrig_unit_Id, setIrrig_unit_Id] = useState(EMPTY);
  const [index, setIndex] = useState(EMPTY);
  const [acres, setAcres] = useState(0);
  const [editRegisteredField, setEditRegisteredField] = useState(false);
  const [geoJsonErrorMessage, setGeoJsonErrorMessage] = useState(false);
  const [regFieldIrrigUnitId, setRegFieldIrrigUnitId] = useState(EMPTY);
  const [regFieldGuid, setRegFieldGuid] = useState(EMPTY);
  const [regFieldId, setRegFieldId] = useState(EMPTY);
  const [maxZoom, setMaxZoom] = useState(12);
  const [latLongValue, setLatLongValue] = useState(null);

  const [allUserRegisteredFields, setAllUserRegisteredFields] = useState(null);
  const [allRegisteredFields, setAllRegisteredFields] = useState(null);
  const [allClaimFields, setAllClaimFields] = useState(null);
  const [allAddedFields, setAllAddedFields] = useState(null);

  const [overlayLoading, setOverlayLoading] = useState(false);
  const [overlayLoadingText, setOverlayLoadingText] =
    useState("Loading Fields...");
  const [doReload, setDoReload] = useState(false);
  const [geoJsonStyle, setGeoJsonStyle] = useState({});

  const [certifiedAcres, setCertifiedAcres] = useState();
  const [registeredFields, setRegisteredFields] = useState();
  const [userRegisteredFields, setUserRegisteredFields] = useState();
  const [claimedFields, setClaimedFields] = useState();
  const [geoJsonKey, setGeoJsonKey] = useState("key");
  const mounted = useRef(true);

  useEffect(() => {
    if (mounted.current) {
      (async function () {
        mounted.current = false;
        setOverlayLoading(true);
        await LoadFieldDetails();
      })();
    } else {
      setMaxZoom(maxZoom);
    }
  });

  useEffect(() => {
    const crypto = require("crypto");
    const hash = crypto
      .createHash("sha1")
      .update(JSON.stringify(AddedFields))
      .digest("hex");
    setGeoJsonKey(hash);
    generateAddedFieldsArray();
  }, [AddedFields]);

  const LoadFieldDetails = async () => {
    try {
      let [certifiedAcresValue, registeredFieldsValue, userFieldDetailsValue] =
        await Promise.all([
          loadAllIrrigationFields(),
          getRegisteredFields(),
          getUserFieldDetails(),
        ]);
      setFarmsAndGrowers(userFieldDetailsValue.data.resources);
      dispatch(formType(SHOW_FIELD));

      let claimedFieldsValue = {
        message: USER_CLAIMED_FIELDS,
        data: userFieldDetailsValue.data.claims,
        code: 200,
      };

      let userRegisteredFieldsValue = {
        message: USER_REGISTERED_FIELDS,
        data: userFieldDetailsValue.data.fields,
        code: 200,
      };

      generateIrrigUnitIdArray(
        registeredFieldsValue,
        userRegisteredFieldsValue,
        claimedFieldsValue
      );

      setCertifiedAcres(certifiedAcresValue);
      setRegisteredFields(registeredFieldsValue);
      setUserRegisteredFields(userRegisteredFieldsValue);
      setClaimedFields(claimedFieldsValue);
      setDoReload(true);
      setOverlayLoading(false);
    } catch (error) {
      setOverlayLoading(false);
      console.error(ERROR_FETCHING_FIELD_DETAILS, error);
    }
  };

  const loadAllIrrigationFields = async () => {
    try {
      let allGeoJson = EMPTY;
      if (IsGeoJsonFetched) {
        allGeoJson = AllGeoJson;
        if (
          allGeoJson.features === undefined ||
          allGeoJson.features.length === 0
        ) {
          setGeoJsonErrorMessage(true);
          return false;
        }
        return allGeoJson;
      } else {
        allGeoJson = await GisLayerService.loadAllIrrigationFields();
        dispatch(setAllGeoJsonPolygon(allGeoJson));
        dispatch(SetFlagToGetGeoJson(true));

        if (allGeoJson.features.length === 0) {
          setGeoJsonErrorMessage(true);
          return false;
        }
        return allGeoJson;
      }
    } catch (error) {
      console.error(ERROR_FETCHING_ALL_IRRIGATION_FIELDS, error);
      setGeoJsonErrorMessage(true);
      return false;
    }
  };

  const getRegisteredFields = async () => {
    try {
      let response = await UserService.getUserRegisteredFields();
      let registeredFieldsValue = response.data;
      return response.status === StatusCodes.OK ? registeredFieldsValue : {};
    } catch (error) {
      console.error(ERROR_FETCHING_REGISTERED_FIELDS, error);
    }
  };

  const getUserFieldDetails = async () => {
    let user_email = loggedInUser || registeredUser;
    let payload = {
      user_email: user_email,
      source: "URM",
      keys: [FIELDS, CLAIMS, RESOURCES],
    };
    try {
      let response = await UserService.getUserFieldDetails(payload);
      let userFieldDetail = response.data;
      return userFieldDetail;
    } catch (error) {
      let responseData = error.response.data;
      if (
        error.response.status === StatusCodes.UNAUTHORIZED &&
        responseData.message.includes(INCOMING_TOKEN_HAS_EXPIRED)
      ) {
        FluentdHelper.logEvent(
          INVALID_CREDENTIALS,
          "RegistrationMap_getUserFieldDetails",
          user_email,
          {
            request: payload,
            response: responseData,
          },
          LOGERROR
        );
        StorageHelper.setItem(SESSION_EXPIRED, true);
        StorageHelper.setItem(SESSION_EXPIRED_MESSAGE, SESSION_HAS_EXPIRED);
        SessionHelper.cleanUpStorageKeys();
        window.location.reload();
      } else {
        console.error(ERROR_FETCHING_FIELD_DETAILS, error);
      }
    }
  };

  const setFarmsAndGrowers = (userResources) => {
    let farms = [];
    let businesses = [];
    if (userResources) {
      for (let i = 0; i < userResources.farms_and_businesses.length; i++) {
        farms.push({
          farmName: userResources.farms_and_businesses[i].farm_name,
          businessName: userResources.farms_and_businesses[i].business_name,
        });
      }
      businesses = userResources.businesses;
      dispatch(setInitialFarms(farms));
      dispatch(setInitialBusiness(businesses));
    }
  };

  const generateIrrigUnitIdArray = (
    registeredFields,
    userRegisteredFields,
    claimedFields
  ) => {
    let tempAllRegisteredFields = _.map(registeredFields.data, "irrig_unit_id");
    let tempAllUserRegisteredFields = _.map(
      userRegisteredFields.data,
      "irrig_unit_id"
    );
    let tempAllClaimFields = _.map(claimedFields.data, "claim_irrig_unit_id");

    setGeoJsonStyle({
      fillColor: AVAILABLE,
      fillOpacity: 0.5,
      color: BLACK,
      weight: 1,
    });

    setAllUserRegisteredFields(tempAllUserRegisteredFields);
    setAllRegisteredFields(tempAllRegisteredFields);
    setAllClaimFields(tempAllClaimFields);
  };

  const generateAddedFieldsArray = () => {
    let tempAddedFields = _.map(AddedFields, "irrig_unit_Id");
    setAllAddedFields(tempAddedFields);
  };

  const onEachPolygon = (polygon, layer) => {
    const FieldStyle = {
      allRegisteredFieldsStyle: { fillColor: REGISTERED, fillOpacity: 0.8 },

      allUserRegisteredFieldsStyle: {
        fillColor: ADDED,
        fillOpacity: 0.8,
        interactive: false,
      },
      allClaimFieldsStyle: {
        fillColor: CLAIM,
        fillOpacity: 0.8,
        interactive: false,
      },
      allAddedFieldsStyle: {
        fillColor: SELECTED,
        fillOpacity: 0.8,
        interactive: false,
      },
    };
    let type = EMPTY;
    layer.setStyle({ className: layer.feature.properties.irrig_unit_id });
    if (_.includes(allRegisteredFields, polygon.properties.irrig_unit_id)) {
      type = "allRegisteredFieldsStyle";
    }
    if (_.includes(allUserRegisteredFields, polygon.properties.irrig_unit_id)) {
      type = "allUserRegisteredFieldsStyle";
      layer.bindTooltip(getFieldName(polygon.properties.irrig_unit_id), {
        permanent: true,
        direction: "left",
        className: "fieldlabel d-none",
      });
    }
    if (_.includes(allClaimFields, polygon.properties.irrig_unit_id)) {
      type = "allClaimFieldsStyle";
    }
    if (_.includes(allAddedFields, polygon.properties.irrig_unit_id)) {
      type = "allAddedFieldsStyle";
    }
    layer.setStyle(FieldStyle[type]);
    layer.on({
      mouseover: (event) => {
        event.sourceTarget.options.fillColor =
          event.originalEvent.target.getAttribute("fill");
        layer.setStyle({ weight: 3 });
      },
      mouseout: (event) => {
        layer.setStyle({ weight: 1 });
      },
      click: (event) => {
        if (AddedFields.length > 0) {
          let isSelectedPolygon = _.find(AddedFields, {
            irrig_unit_Id: layer.feature.properties.irrig_unit_id,
          });
          if (isSelectedPolygon) {
            return false;
          }
        }
        handlePolygonClick(layer);
        setShowOverlay(true);
      },
    });
  };

  const getFieldName = (irrig_unit_id) => {
    if (userRegisteredFields && Object.keys(userRegisteredFields).length > 0) {
      const field = userRegisteredFields.data.filter((item) => {
        return item.irrig_unit_id === irrig_unit_id;
      });
      if (field) {
        return field[0].field_name;
      }
    }
    return EMPTY;
  };

  const hidePopup = () => {
    setShowOverlay(false);
  };

  const removeWells = () => {
    if (wellMarkerArray && wellMarkerArray.length > 0) {
      wellMarkerArray = [];
    }
  };

  const displayWell = (polygon) => {
    let wellProps = polygon.properties.well_properties;
    let wellCoord = [];
    let registeredWells = [];
    for (let key in wellProps) {
      wellCoord.push({
        cords: wellProps[key].coord,
        well_id: wellProps[key].prop.well_id,
        pumpRate: wellProps[key].prop.pump_rate,
      });
      registeredWells.push({
        id: wellProps[key].prop.id,
        well_id: wellProps[key].prop.well_id,
        gpm: wellProps[key].prop.pump_rate,
        ugpm: wellProps[key].prop.pump_rate,
        activeWell: true,
        isElectricWell: true,
      });
    }
    setWell_details(registeredWells);
    setIsWellShown(true);
    setShowPopover(true);
    setShowPanel(false);

    if (wellCoord && wellCoord.length > 0) {
      wellCoord.forEach((well, index) => {
        let wellCords = JSON.parse(well.cords);
        wellMarker = {
          position: {
            lat: wellCords[1],
            lng: wellCords[0],
          },
          markerIcon: L.icon({
            iconUrl: require("../../images/pins/" + index + ".png"),
            iconSize: [15, 24],
            iconAnchor: [-1, 23],
            popupAnchor: [-3, -76],
          }),
        };
        wellMarkerArray.push(wellMarker);
      });
    }
  };

  const fillFieldDetails = (event, irrig_unit_id, idx) => {
    event.preventDefault();
    event.stopPropagation();

    let wells = [];
    const editedField = AddedFields.find((f) => {
      return f.irrig_unit_Id === irrig_unit_id;
    });

    for (let well in editedField.wells) {
      wells.push({
        id: editedField.wells[well].id,
        well_id: editedField.wells[well].well_id,
        gpm: editedField.wells[well].gpm,
        ugpm: editedField.wells[well].ugpm,
        activeWell: editedField.wells[well].active,
        isElectricWell: editedField.wells[well].isElectricWell,
      });
    }
    const acres = editedField.irrigUnit.properties.acres.toFixed(2);
    setFieldName(editedField.fieldName);
    setFarmName(editedField.farmName);
    setWell_details(wells);
    setGroundWaterPercentage(editedField.groundWaterPercentage);
    setSurfaceWaterIrrigation(editedField.surfaceWaterIrrigation);
    setSurfaceWaterPercentage(editedField.surfaceWaterPercentage);
    setIsWellShown(true);
    setShowPopover(true);
    setEditField(true);
    setIndex(idx);
    setAcres(acres);
    setIrrig_unit_Id(irrig_unit_id);

    if (fieldNameError) {
      setFieldNameError(false);
      setFieldError(false);
    }
    setShowOverlay(true);
  };

  const displayPanel = () => {
    setShowPanel(true);
  };

  const togglePanel = () => {
    setShowPanel(!showPanel);
  };

  const hidePanel = () => {
    setShowPanel(false);
  };

  const doPopupVisibleFalse = () => {
    setPopupVisible(false);
  };

  const reloadRegistrationFields = async (count) => {
    setOverlayLoading(true);
    setDoReload(false);
    setShowPanel(false);
    setOverlayLoadingText(REGISTER_FIELD_OVERLAY_LOADING_TEXT);

    let time = 0;
    let fieldsCount = count.length;
    time =
      fieldsCount < 5
        ? 1000
        : fieldsCount >= 5 && fieldsCount < 10
        ? 4000
        : fieldsCount >= 10 && fieldsCount < 15
        ? 6000
        : fieldsCount >= 15 && fieldsCount < 20
        ? 8000
        : fieldsCount >= 20 && fieldsCount <= 25
        ? 10000
        : 12000;
    setTimeout(
      async function () {
        await LoadFieldDetails();
        setOverlayLoading(false);
        setShowPanel(true);
        setDoReload(true);
        setOverlayLoadingText("Loading Map...");
      }.bind(this),
      time
    );
  };

  const resetEditFieldDetails = () => {
    setFieldName(EMPTY);
    setFarmName(EMPTY);
    setSurfaceWaterIrrigation(false);
    setGroundWaterPercentage(EMPTY);
    setSurfaceWaterPercentage(EMPTY);
    setIrrig_unit_Id(EMPTY);
    setEditRegisteredField(false);
    setFieldError(false);
    setShowPopover(false);
    setShowPanel(true);
    setIndex(EMPTY);
    setPopupVisible(false);
    setLatLongValue(null);
    setMaxZoom(null);
    setTimeout(() => {
      setEditField(false);
      setBtnClaimEnabled(false);
    }, 200);
  };

  const fillRegisteredFieldDetails = (
    event,
    fieldIrrigUnitid,
    guid,
    fieldId,
    fieldProperties
  ) => {
    event.preventDefault();
    event.stopPropagation();
    let wells = [];
    for (let well in fieldProperties.well_data) {
      wells.push({
        id: fieldProperties.well_data[well].id,
        well_id: fieldProperties.well_data[well].well_id,
        gpm: fieldProperties.well_data[well].pump_rate,
        ugpm: fieldProperties.well_data[well].updated_pump_rate,
        activeWell: fieldProperties.well_data[well].is_active,
        isElectricWell: fieldProperties.well_data[well].is_electric,
      });
    }
    const acres = parseFloat(fieldProperties.acres).toFixed(2);
    const surfaceGroundPercetage =
      fieldProperties.ground_water_percent !== 0 ||
      fieldProperties.surface_water_percent !== 0
        ? true
        : false;
    setFieldName(fieldProperties.field_name);
    setFarmName(fieldProperties.farm_name);
    setWell_details(wells);
    setGroundWaterPercentage(fieldProperties.ground_water_percent);
    setSurfaceWaterIrrigation(surfaceGroundPercetage);
    setSurfaceWaterPercentage(fieldProperties.surface_water_percent);
    setIsWellShown(true);
    setShowPopover(true);
    setEditRegisteredField(true);
    setAcres(acres);
    setRegFieldIrrigUnitId(fieldIrrigUnitid);
    setRegFieldGuid(guid);
    setRegFieldId(fieldId);

    if (fieldNameError) {
      setFieldNameError(false);
      setFieldError(false);
    }
    setShowOverlay(true);
  };

  const getLayerByIrrigUnitId = (irrig_unit_ID) => {
    let layer = document.getElementsByClassName(irrig_unit_ID)[0];
    return layer;
  };

  const hideWarningPopup = async (event) => {
    event.preventDefault();
    setShowOverlay(false);
    removeWells();
    let layer = getLayerByIrrigUnitId(ActivePolygon.properties.irrig_unit_id);
    layer.setAttribute("fill", btnClaimEnabled ? REGISTERED : AVAILABLE);

    dispatch(selectPolygon(null));
    setPopupVisible(false);
    setBtnClaimEnabled(false);

    displayPanel();
    setTimeout(() => {
      dispatch(formType(SHOW_FIELD));
    }, 1000);
  };

  const latLongIntialState = () => {
    setMaxZoom(null);
    setLatLongValue(null);
  };

  const isRegistrationSucessful = (value) => {
    setRegistrationSucessful(value);
  };

  const handleRegistrationComplete = () => {
    setRegistrationSucessful(false);
    setShowPanel(true);
  };

  const handlePolygonClick = async (layer) => {
    const polygon = layer.feature;
    dispatch(formType(SHOW_FIELD));
    await SessionHelper.handleRefreshToken();

    if (AddedFields.length === 25) {
      dispatch(formType("field_limit"));
      return false;
    }

    const acres = polygon.properties.acres.toFixed(2);
    setSurfaceWaterIrrigation(false);
    setPopupVisible(true);
    setAcres(acres);
    setLatLongValue(null);
    setMaxZoom(null);

    hidePanel();
    let allregisteredFieldsValue = [];
    let allUserClaimIdsValue = [];
    let userRegisteredFieldsValue = [];
    if (userRegisteredFields && Object.keys(userRegisteredFields).length > 0) {
      userRegisteredFields.data.forEach((field) => {
        userRegisteredFieldsValue.push(field.irrig_unit_id);
      });
    }

    if (claimedFields && Object.keys(claimedFields).length > 0) {
      claimedFields.data.forEach((field) => {
        allUserClaimIdsValue.push(field.irrig_unit_id);
      });
    }

    if (registeredFields && Object.keys(registeredFields).length > 0) {
      registeredFields.data.forEach((field) => {
        allregisteredFieldsValue.push(field.irrig_unit_id);
      });
    }

    removeWells();

    if (
      userRegisteredFieldsValue.includes(polygon.properties.irrig_unit_id) ||
      allUserClaimIdsValue.includes(polygon.properties.irrig_unit_id)
    ) {
      setShowOverlay(false);
      dispatch(selectPolygon(polygon));

      chageFieldColor(
        ActivePolygon,
        layer,
        AddedFields,
        allregisteredFieldsValue,
        allUserClaimIdsValue,
        userRegisteredFieldsValue
      );

      displayWell(polygon);
      return false;
    } else if (
      allregisteredFieldsValue.includes(polygon.properties.irrig_unit_id)
    ) {
      if (AddedFields.length > 0) {
        dispatch(formType("show_warning"));
        setBtnClaimEnabled(true);
      } else {
        dispatch(formType("show_confirm"));
        setBtnClaimEnabled(true);
      }
    }

    if (ActivePolygon && Object.keys(ActivePolygon).length > 0) {
      if (layer === ActivePolygon) {
        if (
          allregisteredFieldsValue.includes(
            ActivePolygon.properties.irrig_unit_id
          )
        ) {
          setBtnClaimEnabled(false);
        }
        setShowOverlay(false);
        setPopupVisible(false);
        dispatch(selectPolygon(null));
      } else {
        displayWell(polygon);
        dispatch(selectPolygon(layer.feature));
      }
    } else {
      displayWell(polygon);
      dispatch(selectPolygon(layer.feature));
    }
    chageFieldColor(
      ActivePolygon,
      layer,
      AddedFields,
      allregisteredFieldsValue,
      allUserClaimIdsValue,
      userRegisteredFieldsValue
    );
  };

  const chageFieldColor = (
    activePolygon,
    selectedPolygon,
    selectedFields,
    registeredFields,
    userClaimedFields,
    userRegisteredFields
  ) => {
    selectedPolygon.setStyle({ fillColor: SELECTED }); //blue
    if (
      registeredFields.includes(
        selectedPolygon.feature.properties.irrig_unit_id
      )
    ) {
      selectedPolygon.setStyle({ fillColor: CLAIM }); //Red
    }
    if (
      userRegisteredFields.includes(
        selectedPolygon.feature.properties.irrig_unit_id
      )
    ) {
      selectedPolygon.setStyle({ fillColor: ADDED }); // orange
    }
    if (
      userClaimedFields.includes(
        selectedPolygon.feature.properties.irrig_unit_id
      )
    ) {
      selectedPolygon.setStyle({ fillColor: CLAIM }); //Red
    }

    if (activePolygon) {
      let layer = getLayerByIrrigUnitId(activePolygon.properties.irrig_unit_id);
      layer.setAttribute("fill", AVAILABLE);
      if (registeredFields.includes(activePolygon.properties.irrig_unit_id)) {
        layer.setAttribute("fill", REGISTERED);
      }
      if (
        userRegisteredFields.includes(activePolygon.properties.irrig_unit_id)
      ) {
        layer.setAttribute("fill", ADDED);
      }
      if (userClaimedFields.includes(activePolygon.properties.irrig_unit_id)) {
        layer.setAttribute("fill", CLAIM);
      }

      for (let i = 0; i < selectedFields.length; i++) {
        if (
          activePolygon.properties.irrig_unit_id ===
          selectedFields[i].irrig_unit_Id
        ) {
          layer.setAttribute("fill", SELECTED);
        }
      }
    }
  };

  const fieldPopover = () => {
    const popover = (
      <React.Fragment>
        <Draggable
          enableUserSelectHack={false}
          handle=".popover-header"
          bounds={"parent"}
        >
          <Popover key="popover" id="popover-basic">
            <Claim hideWarningPopup={hideWarningPopup} />
            <AddField
              removeWells={removeWells}
              acres={acres}
              well_details={well_details}
              isWellShown={isWellShown}
              resetEditFieldDetails={resetEditFieldDetails}
              surfaceWaterIrrigation={surfaceWaterIrrigation}
              showPopover={showPopover}
              fieldError={fieldError}
              displayPanel={displayPanel}
              hidePopup={hidePopup}
              editField={editField}
              editRegisteredField={editRegisteredField}
              regFieldIrrigUnitId={regFieldIrrigUnitId}
              regFieldGuid={regFieldGuid}
              regFieldId={regFieldId}
              fieldName={fieldName}
              farmName={farmName}
              doPopupVisibleFalse={doPopupVisibleFalse}
              index={index}
              irrig_unit_Id={irrig_unit_Id}
              getLayerByIrrigUnitId={getLayerByIrrigUnitId}
              registeredFields={registeredFields}
              allUserRegisteredFields={userRegisteredFields}
              btnClaimEnabled={btnClaimEnabled}
              groundWaterPercentage={groundWaterPercentage}
              surfaceWaterPercentage={surfaceWaterPercentage}
            />
          </Popover>
        </Draggable>
      </React.Fragment>
    );
    return popover;
  };

  const displayWellOnEdit = () => {
    removeWells();
    let irrig_unit_id_value = irrig_unit_Id;
    const field = AddedFields.filter((item) => {
      return item.irrig_unit_Id === irrig_unit_id_value;
    });
    if (field[0]) {
      let wellProps = field[0].irrigUnit.properties.well_properties;
      wellProps.forEach((well, index) => {
        let wellCords = JSON.parse(well.coord);
        wellMarker = {
          position: {
            lat: wellCords[1],
            lng: wellCords[0],
          },
          markerIcon: L.icon({
            iconUrl: require("../../images/pins/" + index + ".png"),
            iconSize: [15, 24],
            iconAnchor: [-1, 23],
            popupAnchor: [-3, -76],
          }),
        };
        wellMarkerArray.push(wellMarker);
      });
    }
  };

  const fieldHighlight = (value, multi, irrig_unit_ID, color1, color2) => {
    setMaxZoom(12);
    setLatLongValue(null);
    let layer = document.getElementsByClassName(irrig_unit_ID)[0];
    setMaxZoom(15);
    setLatLongValue(value);
    for (let i = 0; i < 10; i++) {
      setTimeout(() => {
        layer.setAttribute("fill", i % 2 === 0 ? color2 : color1);
      }, multi);
      multi += 500;
    }
  };

  if (editField === true) {
    displayWellOnEdit();
  }
  const mapStyle = {
    width: "100%",
  };

  let popover = fieldPopover();

  return (
    <div>
      <OverlayTrigger
        trigger="click"
        show={showOverlay}
        placement="right"
        key="overlayKey"
        overlay={popover}
      >
        <React.Fragment />
      </OverlayTrigger>
      {geoJsonErrorMessage === true ? (
        <CheckGeoJson />
      ) : (
        <legend>
          <ul className="text-end m-0 legend-fields">
            <li>
              Registered
              <small className="d-block"> (By another farmer)</small>
            </li>
            <li className="registered">
              Registered
              <small className="d-block"> (By you)</small>
            </li>
            <li className="available">Available</li>
            <li className="added">Added</li>
            <li className="claimed">Claimed</li>
          </ul>
          <div
            key="toggle_checkbox"
            className="text-start p-0 m-2 toggle-fields"
          ></div>
        </legend>
      )}
      {doReload !== true ? (
        <LoadingOverlay
          showSpinner={true}
          active={overlayLoading}
          text={overlayLoadingText}
        />
      ) : (
        <React.Fragment>
          {registrationSucessful ? (
            <div className="d-flex align-items-center justify-content-center register-successful">
              <div className="col-sm-8 col-md-6 col-lg-6 text-center">
                <i className="fa fa-check" />
                <h2>Registration Success</h2>
                <div className="alert alert-success text-start" role="alert">
                  Thank you for signing up for the TPNRD Water Data Program! You
                  have successfully created an account and registered your
                  fields!
                  <p>
                    Right now, you can make changes such as adding or deleting
                    fields. Over the coming weeks and months, new features will
                    continue to be added.
                  </p>
                  <p>
                    You can log in into your TPNRD Water Data Program account
                    anytime by going to <a href="/login">water.gisc.cloud</a>
                  </p>
                </div>

                <div className="mt-30">
                  <Button
                    variant="link"
                    onClick={(e) => handleRegistrationComplete()}
                    className="btn-secondary me-2"
                    title={EMPTY}
                    style={{ color: "#6c757d" }}
                  >
                    OK
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            <MapContainer
              className="registration-map"
              style={mapStyle}
              center={MAP_CENTER}
              zoom={12}
              scrollWheelZoom={true}
              attributionControl={false}
            >
              <ChangeMap latLongValue={latLongValue} maxZoom={maxZoom} />
              <GeoJSON
                key={geoJsonKey}
                style={geoJsonStyle}
                data={certifiedAcres.features}
                onEachFeature={onEachPolygon}
              ></GeoJSON>
              <TileLayer url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}" />
              {wellMarkerArray.map((marker, idx) => (
                <Marker
                  key={idx}
                  position={[marker.position.lat, marker.position.lng]}
                  icon={marker.markerIcon}
                >
                  {" "}
                </Marker>
              ))}
            </MapContainer>
          )}
        </React.Fragment>
      )}
      <RegisterPanel
        className="reg-panel"
        panelStatus={showPanel}
        PanelHide={(e) => hidePanel()}
        panelToggle={(e) => togglePanel()}
        removeWells={(e) => removeWells()}
        getLayerByIrrigUnitId={getLayerByIrrigUnitId}
        allUserRegisteredFields={userRegisteredFields}
        userClaimedFields={claimedFields}
        latLongIntialState={latLongIntialState}
        isRegistrationSucessful={(s) => isRegistrationSucessful(s)}
        fillFieldDetails={(e, irrig_unit_id, idx) =>
          fillFieldDetails(e, irrig_unit_id, idx)
        }
        fillRegisteredFieldDetails={(
          event,
          fieldIrrigUnitid,
          guid,
          fieldId,
          fieldProperties
        ) =>
          fillRegisteredFieldDetails(
            event,
            fieldIrrigUnitid,
            guid,
            fieldId,
            fieldProperties
          )
        }
        fieldHighlight={(value, multi, irrig_unit_ID, color1, color2) =>
          fieldHighlight(value, multi, irrig_unit_ID, color1, color2)
        }
        field_map={props.field_map}
        reloadRegistrationFields={(count) => reloadRegistrationFields(count)}
      />
      <LoadingOverlay
        showSpinner={false}
        active={editField || editRegisteredField === true ? true : popupVisible}
        opacity={0.2}
      />
    </div>
  );
}

export default RegisterMap;
